export default "__VITE_ASSET__c07554f0__"